import React, {useState, useEffect} from "react";
import Select from "react-select";
import {useTranslation} from "react-i18next";
import {addSelectData} from "@redux/select/Action";
import {useDispatch, useSelector} from "react-redux";
import _ from "lodash";

const ApiSelect = ({
                     service,
                     reduxKey,
                     onSelect,
                     selected,
                     placeholder,
                     extraParams,
                     disabled = false,
                     isClearable = false,
                     showModal = true,
                   }) => {
  const {i18n} = useTranslation();
  const language = i18n.language;
  const dispatch = useDispatch();
  const [selectedObject, setSelectedObject] = useState();

  // eslint-disable-next-line no-undef
  const options = useSelector((state) =>
    _.get(state, `selectDataReducer.${reduxKey}`, [])
  );

  const handleChangeSelected = (item, triggeredAction) => {
    if (triggeredAction.action === 'clear'){
      setSelectedObject();
      onSelect();
    }
    setSelectedObject(item);
    onSelect && onSelect(item.id);
  };

  useEffect(() => {
    if(showModal) {
      service.all(extraParams).then((response) => {
        dispatch(addSelectData({[reduxKey]: response.data?.data}));
      });
    }}, [dispatch, reduxKey, extraParams, service, showModal]);

  useEffect(() => {
    const foundItem = Object.values(options)?.find(
      (item) => item.id === selected
    );
    setSelectedObject(foundItem ? foundItem : null);
  }, [selected, options]);

  return (
    <Select
      isClearable={isClearable}
      isDisabled={disabled}
      getOptionValue={(option) => option.name}
      menuPortalTarget={document.body}
      styles={{menuPortal: (base) => ({...base, zIndex: 9999})}}
      isSearchable={true}
      options={options}
      onChange={handleChangeSelected}
      value={selectedObject}
      placeholder={placeholder}
      getOptionLabel={(selectedObject) => (
        <div
          style={{display: "flex", justifyContent: "space-between"}}
          className="text-sm"
        >
          <span style={{marginLeft: 5}}>
            {language === "al" ? selectedObject.name : selectedObject.name_eng}
          </span>
        </div>
      )}
    />
  );
};

export default ApiSelect;
